export function getUTMParams(): Record<string, string> {
  const params = new URLSearchParams(window.location.search)
  const utm: Record<string, string> = {}
  for (const [key, value] of params.entries()) {
    if (key.startsWith('utm_')) {
      utm[key] = value
    }
  }
  return utm
}

export function saveUTMToSessionStorage() {
  const utm = getUTMParams()
  if (Object.keys(utm).length > 0) {
    sessionStorage.setItem('utm_params', JSON.stringify(utm))
  }
}

export function getUTMFromStorage(): Record<string, string> {
  try {
    return JSON.parse(sessionStorage.getItem('utm_params') || '{}')
  } catch {
    return {}
  }
}

export function appendUTMToUrl(url: string): string {
  const utm = getUTMFromStorage()
  if (!Object.keys(utm).length) {
    return url
  }

  const urlObj = new URL(url, window.location.origin)
  Object.entries(utm).forEach(([key, value]) => {
    urlObj.searchParams.set(key, value)
  })

  return urlObj.pathname + urlObj.search
}
